'use client';

import { Provider } from 'react-redux';
import { store } from '@/store/store';
import { SessionProvider } from 'next-auth/react';
import { TokenExpiryProvider } from '@/components/auth/TokenExpiryProvider';
import { useTokenRefresh } from '@/hooks/useTokenRefresh';
import { useTabFocus } from '@/hooks/useTabFocus';
import { SessionErrorHandler } from '@/components/auth/SessionErrorHandler';

function TokenRefreshManager() {
  useTokenRefresh();
  useTabFocus();
  return null;
}

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <Provider store={store}>
      <SessionProvider refetchInterval={0} refetchOnWindowFocus={false}>
        <SessionErrorHandler />
        <TokenRefreshManager />
        <TokenExpiryProvider warningTime={60} checkInterval={60000}>
          {children}
        </TokenExpiryProvider>
      </SessionProvider>
    </Provider>
  );
}
